import { render, staticRenderFns } from "./FieldExerciseResearch.vue?vue&type=template&id=2df08267&scoped=true"
import script from "./FieldExerciseResearch.vue?vue&type=script&lang=js"
export * from "./FieldExerciseResearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df08267",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df08267')) {
      api.createRecord('2df08267', component.options)
    } else {
      api.reload('2df08267', component.options)
    }
    module.hot.accept("./FieldExerciseResearch.vue?vue&type=template&id=2df08267&scoped=true", function () {
      api.rerender('2df08267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldExerciseResearch.vue"
export default component.exports